import React, { Dispatch, SetStateAction, useMemo } from "react";
import styles from "./radioButton.module.scss";

import { RadioChecked, RadioCheckedDisabled, RadioDefault, RadioDisabled } from "../../icons/24";

interface RadioProps {
  id: string;
  name: string;
  value: string;
  setValue: Dispatch<SetStateAction<string>> | ((val: string) => void);
  checked: boolean;
  disabled?: boolean;
  labelComponent?: React.ReactNode;
  className?: string;
}

const RadioButton = ({
  id,
  name,
  value,
  setValue,
  checked,
  disabled = false,
  labelComponent,
  className,
}: RadioProps) => {
  // 이전 스타일 미적용될 수 있어서 추가
  const prevClassCheck = className ? className?.includes("input-radio-wrap") : false;
  const RadioIcon = React.memo(({ disabled, checked }: { disabled: boolean; checked: boolean }) => {
    if (disabled) {
      if (checked) {
        return <RadioCheckedDisabled />;
      } else {
        return <RadioDisabled />;
      }
    } else {
      if (checked) {
        return <RadioChecked />;
      } else {
        return <RadioDefault />;
      }
    }
  });
  const IconMemo = useMemo(
    () => <RadioIcon disabled={!!disabled} checked={!!checked} />,
    [disabled, checked],
  );

  return (
    <>
      <div className={`${styles["input-radio-wrap"]} ${className ? className : ""}`}>
        <input
          id={id}
          type="radio"
          name={name}
          className={`${styles["input-radio"]} only-sr ${prevClassCheck ? "input-radio" : ""}`}
          value={value}
          checked={checked}
          onChange={() => setValue(value)}
          disabled={disabled}
        />
        <label
          // htmlFor={id} // input 영역으로 스크롤 이동되는 현상 방지하기 위해 htmlFor 대신 onClick 사용
          onClick={(e) => {
            e.preventDefault();
            setValue(value);
          }}
        >
          {IconMemo}
        </label>
      </div>
      {labelComponent && (
        <label
          className={`${styles["input-radio-label"]} ${prevClassCheck ? "input-radio-label" : ""}`}
          // htmlFor={id} // input 영역으로 스크롤 이동되는 현상 방지하기 위해 htmlFor 대신 onClick 사용
          onClick={(e) => {
            e.preventDefault();
            setValue(value);
          }}
        >
          {labelComponent}
        </label>
      )}
    </>
  );
};

export default RadioButton;
